import angular from 'angular';
const componentOptions = {
    bindings: {
        model: '=',
        containerForm: '=',
        show: '<'
    },
    controllerAs : 'giftCardsReceiverCtrl',
    templateUrl: ['GiftCardsAppConstants', (GiftCardsAppConstants: GiftCardsAppConstant): string => `${GiftCardsAppConstants.templatesRoute}ib-gift-cards-receiver-view.html`]
};
const componentInfo = {
    module: 'ib-gift-cards-configuration-form-module',
    selector: 'ibGiftCardsReceiver',
    inject:['GiftCardsAppConstants'],
    required: []
};
export class ibGiftCardsReceiver implements ng.IController {
    public model: Types.DestinataryInfo;
    public MAX_LENGTH_NAME : number;
    public NAME_SURNAME_PATTERN: RegExp;
    public NAME_SURNAME_CLEANER: string;
    constructor (private GiftCardsAppConstants: GiftCardsAppConstant) {
        this.MAX_LENGTH_NAME = this.GiftCardsAppConstants.MAX_FIELD_LENGTH.MAX_LENGTH_NAME;
        this.NAME_SURNAME_PATTERN = this.GiftCardsAppConstants.PATTERNS.NAME_SURNAME_PATTERN;
        this.NAME_SURNAME_CLEANER = this.GiftCardsAppConstants.PATTERNS.NAME_SURNAME_CLEANER;
    }
}
try {
    const mod = angular.module(componentInfo.module);
    ibGiftCardsReceiver.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsReceiver })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibGiftCardsReceiver.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsReceiver })
    );
}
